const localStorage = {
  isNull(input) {
    return input === undefined || input === null;
  },
  saveLocal(name, value) {
    if (window.localStorage && JSON && name) {
      if (typeof value === 'object') {
        value = JSON.stringify(value);
      }
      window.localStorage.setItem(name, value);
      return true;
    }
    return false;
  },
  getLocal(name) {
    if (window.localStorage && JSON && name) {
      const data = window.localStorage.getItem(name);
      // console.log('getLocal:', JSON.parse(data));
      return JSON.parse(data);
    }
    return null;
  },
  removeLocal(name) {
    if (window.localStorage && JSON && name) {
      window.localStorage.removeItem(name);
    }
    return null;
  }
};

export default localStorage;
